import { memoize } from 'lodash';

import AxelType from '../type/type.type';

export interface DatumModel {
  data: any;
  value: () => AxelType;
  format: (value: any) => string | number;
  type: () => string;
}

export default function datum(data, value, format, memoizable): DatumModel {
  const type = () => {
    if (typeof value().valueOf() === 'number') {
      return 'number';
    } else {
      return 'string';
    }
  };
  if (memoizable) {
    return { data, value: memoize(value), format: memoize(format), type: memoize(type) };
  } else {
    return { data, value: value, format: format, type: type };
  }
}
